import React from 'react';
import * as ROUTES from '../../router/Routes';
import ContainerTemplate from '../../widgets/template/Container';
import ResumenesView from './ResumenesView';

const ResumenesModule = () => {
  return (
    <ContainerTemplate active={ROUTES.resumenes} routes={[]}>
      <ResumenesView />
    </ContainerTemplate>
  );
};

export default ResumenesModule;
